module.exports = __webpack_public_path__ + "static/img/4.6c92298.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.png
// module id = 482
// module chunks = 1